import Vue from 'vue'
export const state = () => ({})

export const mutations = {
  setApiStatus(state, { key, value }) {
    Vue.set(state, key, value)
  }
}
